<template>
  <div>
    <div class="top">
      <div class="top-img">
        <img src="./../assets/2024/header-home.png" alt="对邪教说不">
      </div>
    </div>
    <div class="success">
      <div :class="{'visible': stopAnimate}">
        <p v-if="signNumber"><small> NO: QM{{ signNumber.padStart(8, '00000000') }}，您的专属编号已激活！ </small><br/>恭喜获得“反邪卫士”荣誉勋章</p>
        <p v-else style="margin-bottom: 3%">恭喜获得“反邪卫士”荣誉勋章</p>
        <div class="badge-img"></div>
      </div>
    </div>
    <p class="address" v-show="address"><img src="./../assets/location-white.png" style="width: 13px !important;height: auto;" alt="">{{ address }}</p>
    <div class="button">
      <a
        @click="goToExam"
        ref="noreferrer noopener"
      >
        <div>
          <span>反邪教知识答题</span>
        </div>
      </a>
    </div>
    <div class="more">
      <div @click="showShareHandle" class="flex-1">
        <div>
          <img src="./../assets/share-icon.png" alt="分享" />
        </div>
        <div>
          <a>分享</a>
        </div>
      </div>
      <div @click="showRank" class="flex-1">
        <div>
          <img src="./../assets/rank-icon.png" alt="签名量统计" />
        </div>
        <div>
          <a>签名量统计</a>
        </div>
      </div>
      <div @click="showFollow" class="flex-1">
        <div>
          <img src="./../assets/more-icon.png" alt="更多精彩" />
        </div>
        <div>
          <a>更多精彩</a>
        </div>
      </div>
    </div>
    <Rank :show="showRankDialog" @close="closeRank"></Rank>
    <Share
      :show="showShareDialog"
      @close="closeShareDialog"
    ></Share>
    <follow-account
      :show="showFollowDialog"
      @close="closeFollow"
    ></follow-account>
  </div>
</template>

<script>
import Share from '@/components/Share.vue'
import FollowAccount from '@/components/FollowAccount.vue'
import Rank from "@/components/Rank.vue";
import wechatUtils from "@/api/wechat"
import userApi from "@/api/user"
import { convertAddressToChinese } from '@/utils/address'

export default {
  name: 'Success',
  components: {
    Share,
    FollowAccount,
    Rank,
  },
  data() {
    return {
      showShareDialog: false,
      showRankDialog: false,
      showFollowDialog: false,
      stopAnimate: false,
      signNumber: null,
      address: '',
    }
  },
  created() {
    // 提前预加载勋章图片，避免背景图逐块显示
    const preload = new Image()
    preload.src = require('./../assets/sign-in-success.png')
  },
  mounted() {
    // const obj = new WxLogin({
    //   "self_redirect": true,
    //   id: "login_container", 
    //   appid: "", 
    //   scope: "", 
    //   "redirect_uri": "",
    //   state: "",
    //   style: "",
    //   href: ""
    // });
    // console.log(obj);
    wechatUtils.config()
    if (this.$route.query.signNumber != undefined && this.$route.query.signNumber != "undefined"
     && this.$route.query.signNumber != "null" && this.$route.query.signNumber != null && this.$route.query.signNumber != "") {
      this.signNumber = this.$route.query.signNumber
    } else {
      // 获取签名编号
      userApi.getRank({}).then(async res => {
        this.signNumber = res.rank
        this.address = await convertAddressToChinese(res.province, res.city, res.county, res.town)
      })
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.$toast.text("<p>您已成功获得<br>“反邪卫士”荣誉勋章</p>");
        this.stopAnimate = true
      }, 500)
    })
  },
  methods: {
    goToExam() {
      this.$router.push({ path: '/platform' })
    },
    showShareHandle() {
      this.showShareDialog = true
    },
    closeShareDialog() {
      this.showShareDialog = false
    },
    showFollow() {
      this.showFollowDialog = true
      // this.$router.push('/')
    },
    closeFollow() {
      this.showFollowDialog = false
    },
    showRank() {
      this.showRankDialog = true;
    },
    closeRank() {
      this.showRankDialog = false;
    },
  }
}
</script>
<style lang="scss" scoped>
.more {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 3px;
  div {
    flex: 1;
  }
  img {
    width: 65px;
  }
  a {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    font-weight: 500;
    display: inline-block;
    border-radius: 50px;
    padding: 5px 15px;
    background: rgba(0, 0, 0, 0.6);
  }
}

.success {
  width: 96vw;
  margin: auto;
  display: inline-block;
  margin-top: -17vw;
  text-align: center;
  position: relative;
  
  div {
    width: 100%;
    visibility: hidden;
    transform:  scale(1);
    transform-origin: center;
    animation: animateText .5s linear .3s 1 forwards;
    text-align: center;
    p {
      font-size: 16px;
      width: 100%;
      position: absolute;
      bottom: 9%;
      color: #fff;
      z-index: 1;
      text-align: center;
      small {
        font-size: 12px;
      }
    }
    .badge-img {
      width: 90%;
      aspect-ratio: 743 / 506;
      background: url('./../assets/sign-in-success.png') no-repeat center;
      background-size: contain;
      margin: 0 auto;
    }
  }
}
.visible {
  visibility: visible !important;
}
@keyframes animateText {
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(0.9);
    visibility: visible;
  }
  100% {
    transform: scale(1);
    visibility: visible;
  }
}
.address {
  font-size: 12px;
  color: #fff;
  margin: 0 0 10px 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0 40px;
  img {
    margin: 2px 2px 0 0;
    width: 13px !important;
    height: auto;
  }
}
.button {
  a {
    color: #fff;
    border-radius: 50px;
    border: 5px solid rgba(255, 255, 255, 0.44);
    display: inline-block;
    width: 80%;
    text-decoration: none;

    div {
      box-shadow: 0 1px 5px 0px rgba(0, 0, 0, 0.4);
      width: 100%;
      height: 100%;
      border-radius: 50px;
      padding: 10px 0;
      box-sizing: border-box;
      background: linear-gradient(to bottom, #FFAC49, #F87200);
    }
  }
}
.top-img {
  img {
    max-width: 100%;
  }
}
</style>
